import Mixins from '@tribus/component-mixins';

/**
  * Icon component
  */
export default {
  name: 'icon',
  mixins: [
    Mixins.ie11, Mixins.isSandbox
  ],
  props: {
    /**
      * Basename for the icon being used
      */
    base: {type: String, required: true},
    /**
      * Build path (where sprites are saved)
      */
    buildPath: {type: String, default: '/build/sprite'},
    /**
      * Icon title
      */
    title: {type: String, default: 'Icon'},
    /**
    * File extension of icon (png, svg)
    */
    type: {type: String, default: 'svg'}
  },
  computed: {
    sprite() {
      return (!this.isSandbox && !this.isIE11());
    },
    spritePath() {
      return `${this.buildPath}/sprite.${this.type}`;
    }
  },
  methods: {
    svg() {
      return require(`!html-loader!@img/${this.base}.svg`);
    }
  }
};
